// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"880":"1fa97dc9","2289":"d25ec183","4223":"532191f7","4573":"33e44baa","6917":"334653f2"}[chunkId] + ".chunk.css";
};